const tableCellExpiredServices = {
  photo: 'FOTO'
};

export default tableCellExpiredServices;
